// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import LandingPage from "./auth/LandingPage";
// import Login from "./auth/Login";
// import ForgotPassword from "./auth/ForgotPassword";
// import Signup from "./auth/Signup";
// // import Dashboard from "./auth/Dashboard";
// import Dashboard from "./components/Dashboard"
// import MainLayout from "./layout/MainLayout";
// import { AuthProvider } from "./context/AuthContext";

// import Interest from "./pages/Intersest";
// import EvolvRewards from "./pages/EvolvRewards";
// import MasterLoaction from "./pages/MasterLoaction";
// import PrivateRoute from "./utils/PrivateRoute";
// import Profile from "./pages/Profile";
// import RewardsPage from "./pages/RewardsPage";
// import Home from "./pages/Home";
// import "./index.css";

// function App() {
//   return (
//     <AuthProvider>
//       <Routes>
//         {/* For Login  */}
//         <Route path="/login" element={<Login />} />

//          {/* Protected Routes */}
//         <Route element={<PrivateRoute />}>
//             {/* <Route path="/" element={<MainLayout />}> */}
//             <Route path="/dashboard" element={<Dashboard />} />
//             <Route path="/home" element={<Home />} />
//             <Route path="/profile" element={<Profile />} />
//             <Route path="/rewardsPage" element={<RewardsPage />} />
//           </Route>

//        {/* Defult Routes */}
//         <Route path="/" element={<LandingPage />} />

//         <Route path="/forgot-password" element={<ForgotPassword />} />

//         <Route path="/signup" element={<Signup />} />
//         <Route path="/interest" element={<Interest />} />
//         <Route path="/rewards" element={<EvolvRewards />} />
//         <Route path="/allLocation" element={<MasterLoaction />}

//         />

//         {/* <Route
//           path="/dashboard"
//           element={
//             // <MainLayout>
//               <Dashboard />
//             // </MainLayout>
//           }
//         /> */}
//       </Routes>
//     </AuthProvider>
//   );
// }

// export default App;

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./auth/LandingPage";
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import Signup from "./auth/Signup";
import MainLayout from "./layout/MainLayout";
import { AuthProvider, useAuth } from "./context/AuthContext";
import PrivateRoute from "./utils/PrivateRoute";
import Dashboard from "./components/Dashboard";
import Profile from "./pages/Profile";
import RewardsPage from "./pages/RewardsPage";
import Home from "./pages/Home";
import "./index.css";

import Interest from "./pages/Intersest";
import EvolvRewards from "./pages/EvolvRewards";
import MasterLoaction from "./pages/MasterLoaction";

function App() {
  const { authToken } = useAuth();
  console.log(authToken);
  return (
    <Routes>
      {/* Login and Public Routes */}
      {authToken ? (
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<Dashboard />}>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Navigate to={"/"} />} />
            {/* <Route path="/dashboard/home" element={<Home />} /> */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/rewardsPage" element={<RewardsPage />} />
          </Route>
        </Route>
      ) : (
        <>
          <Route path="/" element={<LandingPage />} />
          <Route path="*" element={<Navigate to={"/"} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/interest" element={<Interest />} />
          <Route path="/rewards" element={<EvolvRewards />} />
          <Route path="/allLocation" element={<MasterLoaction />} />{" "}
        </>
      )}
    </Routes>
  );
}

export default App;
